/* aesir-custom.js — small, targeted enhancements.
   ------------------------------------------------------------------
   1) Make the WHOLE "I AM BASKETBALL" product card clickable again.
      The theme's default clickable card relies on `.card__heading a::after`
      (a CSS stretched-link pseudo). We repurposed that ::after to render the
      "(designed by Naisoon)" subtitle, so the stretched link was lost and
      only the title text stayed clickable.
      Fix: inject a real, transparent, full-card overlay <a> that points to
      the same product URL. Real anchors keep hover/keyboard behaviour.
      We only touch the basketball card (matched by its product href). */
(function () {
  'use strict';

  var MATCH = '/products/i-am-basketball';

  function enhanceBasketballCard() {
    var links = document.querySelectorAll('.product-grid a[href*="' + MATCH + '"]');
    if (!links.length) return;

    // De-duplicate to the card wrappers that contain the basketball product.
    var wrappers = [];
    links.forEach(function (a) {
      var w = a.closest('.card-wrapper') || a.closest('.grid__item');
      if (w && wrappers.indexOf(w) === -1) wrappers.push(w);
    });

    wrappers.forEach(function (wrapper) {
      if (wrapper.querySelector(':scope > .card-stretched-link')) return; // already done

      // Find the visible product anchor (skip the hidden *NoMediaLink* dupes).
      var productLinks = wrapper.querySelectorAll('a[href*="' + MATCH + '"]');
      var href = null;
      for (var i = 0; i < productLinks.length; i++) {
        var r = productLinks[i].getBoundingClientRect();
        if (r.width > 0 && r.height > 0) { href = productLinks[i].getAttribute('href'); break; }
      }
      if (!href && productLinks.length) href = productLinks[0].getAttribute('href');
      if (!href) return;

      var overlay = document.createElement('a');
      overlay.className = 'card-stretched-link';
      overlay.setAttribute('href', href);
      overlay.setAttribute('aria-label', 'View product');
      // Text kept empty; it is purely a click target.
      wrapper.appendChild(overlay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceBasketballCard);
  } else {
    enhanceBasketballCard();
  }
  // Theme editor / section reloads
  document.addEventListener('shopify:section:load', enhanceBasketballCard);
  window.addEventListener('load', enhanceBasketballCard);
})();
